require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#d7893b',
        accent: '#B13F1A',
        secondary: '#8A8D93',
        success: '#86b809',
        info: '#9155FD',
        warning: '#E6B371',
        error: '#FF4C51',
        mobilePrimary: '#1f4168',
        mobileSecondary: '#000000',
      },
      dark: {
        primary: '#d7893b',
        accent: '#B13F1A',
        secondary: '#8A8D93',
        success: '#86b809',
        info: '#9155FD',
        warning: '#E6B371',
        error: '#FF4C51',
        mobilePrimary: '#1f4168',
        mobileSecondary: '#000000',
      },
    //   dark: {
    //     primary: '#9155FD',
    //     accent: '#0d6efd',
    //     secondary: '#8A8D93',
    //     success: '#56CA00',
    //     info: '#16B1FF',
    //     warning: '#FFB400',
    //     error: '#FF4C51',
    //   },
    },
  },
}
